export default "__VITE_ASSET__Dfgog9Mw__"